import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { getToken } from '../utils/authStorage';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const VisitorPageTracker = ({ user }) => {
  const location = useLocation();
  const last = useRef('');
  useEffect(() => {
    if (!user?.is_visitor) return;
    const path = location.pathname;
    if (path === last.current) return;
    last.current = path;
    const token = getToken();
    if (!token) return;
    fetch(`${BACKEND_URL}/api/visitor/pagina`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ path }),
    }).catch(() => {});
  }, [location.pathname, user]);
  return null;
};
